import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Layout from '@/views/layout'
import Quotation from '@/views/quotation'
import Order from '@/views/order'
import ShoppingCart from '@/views/shoppingCart'
import Profile from '@/views/profile'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'Quotation',
        component: Quotation
      },
      {
        path: '/order',
        name: 'Order',
        component: Order,
      },
      {
        path: '/shoppingCart',
        name: 'ShoppingCart',
        component: ShoppingCart
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile
      },
    ]
  },
  {
    path: '/robotQuote',
    name: 'RobotQuote',
    meta: {
      auth: true
    },
    component: () => import( '@/views/robotQuote')
  },
  {
    path: '/carTypeDetail',
    name: 'CarTypeDetail',
    component: () => import( '@/views/carTypeDetail')
  },
  {
    path: '/orderDetail',
    name: 'OrderDetail',
    component: () => import('@/views/order/components/OrderDetail')
  },
  {
    path: '/address',
    name: 'Address',
    component: () => import('@/views/address')
  },
  {
    path: '/editAddress',
    name: 'EditAddress',
    component: () => import('@/views/address/EditAddress')
  },
  {
    path: '/payDetails',
    name: 'PayDetails',
    component: () => import('@/views/pay/PayDetails')
  },
  {
    path: '/quotationDetail/:id',
    name: 'QuotationDetail',
    component: () => import( '@/views/quotation/components/QuotationDetail')
  },
  {
    path: '/customQuotationDetail/:id',
    name: 'CustomQuotationDetail',
    component: () => import( '@/views/quotation/components/CustomQuotationDetail')
  },
  {
    path: '/orderDetails',
    name: 'OrderDetails',
    component: () => import('@/views/order/components/OrderDetails')
  },
  {
    path: '/robotInquiry',
    name: 'RobotInquiry',
    meta: {
      auth: true
    },
    component: () => import( '@/views/robotInquiry')
  },
  {
    path: '/inputText',
    name: 'InputText',
    component: () => import( '@/views/inputText')
  },
  {
    path: '/confirmInquiry',
    name: 'ConfirmInquiry',
    component: () => import( '@/views/confirmInquiry')
  },
  {
    path: '/robotInquiryAdd',
    name: 'RobotInquiryAdd',
    meta: {
      auth: true
    },
    component: () => import( '@/views/robotInquiryAdd')
  },
  {
    path: '/robotInquiryMultiAdd',
    name: 'RobotInquiryMultiAdd',
    component: () => import( '@/views/robotInquiryMultiAdd')
  },
  {
    path: '/h5Pay',
    name: 'H5Pay',
    meta: {
      whiteList: true
    },
    component: () => import( '@/views/whiteList/H5Pay')
  },
  {
    path: '/billDetails',
    name: 'BillDetails',
    meta: {
      whiteList: true
    },
    component: () => import( '@/views/whiteList/BillDetails')
  },
  {
    path: '/h5OrderDetails',
    name: 'H5OrderDetails',
    meta: {
      whiteList: true
    },
    component: () => import( '@/views/whiteList/H5OrderDetails')
  },
  {
    path: '/partsDetail',
    name: 'PartsDetail',
    component: () => import( '@/views/partsDetail')
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  if (to.meta.whiteList) {
    next()
    return
  }
  if(to.meta.auth) {
    await store.dispatch('user/getUserInfo')
    next()
    return
  }
  next()
})

export default router
